import React from "react";
import TextTheme from "components/General/Text/TextTheme";
import OnboardingStepper from "components/Account/Onboarding/OnboardingStepper";
import TextArea from "components/General/Form/TextArea";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import "containers/Account/Onboarding/Onboarding.css";
import AxiosConfig from "axiosConfig";


class Believer extends React.Component {
  state = {
    superpower: "",
  };

  componentDidMount() {
      AxiosConfig.get("profile/details/").then((res) => {
          this.setState({
              superpower: res.data.super_powers,
          });
      });
    }

  onDataChange(event){
      this.setState({ [event.target.name]: event.target.value });
   }

   createFormData() {
    let form_data = new FormData();
    if (this.state.superpower)

        form_data.append("super_powers", this.state.superpower);
     return form_data;
}

  onNextClicked(event)
  {
    event.preventDefault();
    let form_data = this.createFormData();

    return AxiosConfig.put('profile/details/', form_data,
    {headers: {'content-type': 'multipart/form-data'}})
    .then(this.props.history.push(`/onboarding-cause`))
    .catch();
  }

  onSkipClicked(event)
  {
    this.props.history.push(`/onboarding-cause`)
  }


  render() {
    return (
      <div>
        <div className="onboarding_header">
          <div className="onboarding_header_text">
            <TextTheme
              message="Before we start, let's build your"
              className="text_xm text_white text_bold"
            />
            <TextTheme
              message="Personalized Social Impact Profile!"
              className="text_xm text_white text_bold"
            />
          </div>
          <div className="onboarding_header_stepper">
            <OnboardingStepper currentOnboardingStep="2" />
          </div>
        </div>
        <div className="onboarding_content">
          <div
            style={{ width: "fit-content", align: "center", margin: "auto" }}
          >
            </div>
          
          <div style={{ marginTop: "0px" }}>
            <TextArea
              title="I have superpowers to..."
              rows="6"
              placeholder="Tell us your special strengths and abilities yo can use to make the world a better place."
              name="superpower"
              value={this.state.superpower}
              handleChange={this.onDataChange.bind(this)}
            />
          </div>

          <div className="onboarding_button_options">
            <RoundedButton
              title="Skip for now, maybe later."
              buttonClassName="background_white"
              textThemeClassName="text_medium text_dark_orange"
              handleOnClick = {this.onSkipClicked.bind(this)}
            />
            <RoundedButton
              title="&nbsp;&nbsp;&nbsp;Next&nbsp;&nbsp;&nbsp;"
              buttonClassName="background_dark_orange"
              textThemeClassName="text_medium text_white"
              handleOnClick = {this.onNextClicked.bind(this)}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Believer;
